import { Injectable } from '@angular/core';

import { SyncUserSettingsService, UserService } from '@frontend/sports/user/feature';
import { Decimal } from 'decimal.js';

import { ISlip } from '../../../../bet-generation/models';
import { StakeNotDividablePreCheckError } from '../../../errors/pre-check/stake-not-dividable-pre-check-error';
import { StakeNotDividableValidator } from '../stake-not-dividable-validator.service';

@Injectable()
export class BetStakeNotDividableValidator extends StakeNotDividableValidator<StakeNotDividablePreCheckError> {
    constructor(userService: UserService, userSettings: SyncUserSettingsService) {
        super(userService, userSettings);
    }

    validate(slip: ISlip): Iterable<StakeNotDividablePreCheckError> {
        return this.validateInternal(slip.stake);
    }

    protected createError(exampleStakes: Decimal[], dividend: Decimal): StakeNotDividablePreCheckError {
        return new StakeNotDividablePreCheckError(exampleStakes, dividend);
    }
}
